import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const usePatients = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);
    const userId = authState.userId;

    const actions = {
        add: false,
        edit: false,
        delete: false,
    };

    return {
        userId,
        actions
    }
};

export default usePatients;
